import React from 'react'
export default React.createContext(); // Create a context object